function loadQuickViewContent(fetchedUrl) {

  return fetch(fetchedUrl)
    .then((response) => response.text())
    .then((html) => {
      var innerWidth = window.innerWidth;

      if (innerWidth < 600) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

        return html;
      } else {
        return html;
      }
    })
    .catch((error) => {
      console.warn(error);
    });
}

document.addEventListener('recommendations:loaded', function () {
  productForm();
});

document.addEventListener('drawerclosed', function () {
  afterDrawerClose();
});

var quickViewContainer = document.querySelector('#fetchUrlContent');

function productForm() {

  var quickViewTriggers = document.querySelectorAll('[data-fetch-url]');

  quickViewTriggers.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      var fetchedUrl = this.getAttribute('data-fetch-url');
      var fetchedContent = loadQuickViewContent(fetchedUrl);

      fetchedContent.then(function (data) {
        quickViewContainer.innerHTML = data
        quickViewContainer.classList.add('is-open');
        var quickViewOverlay = document.querySelector('.popup-layover');
        quickViewOverlay.classList.add('is-open');
        if (quickViewOverlay) {
          quickViewOverlay.addEventListener("click", function () {
            document.querySelector('#fetchUrlContent').classList.remove('is-open');
            quickViewContainer.innerHTML = '';
            quickViewOverlay.classList.remove('is-open');
          });
        }

        var quickViewCloseBtn = document.querySelector('#quickviewClose');
        if (quickViewCloseBtn) {
          quickViewCloseBtn.addEventListener("click", function () {
            document.querySelector('#fetchUrlContent').classList.remove('is-open');
            document.querySelector('.popup-layover').classList.remove('is-open');
            quickViewContainer.innerHTML = '';
          });
        }
        var increaseQuantity = document.querySelector('#increaseQuantity');
        var decreaseQuantity = document.querySelector('#decreaseQuantity');
        var addedQuantity = document.querySelector('#Quantity');

        if (increaseQuantity) {
          increaseQuantity.addEventListener("click", function () {
            var value = parseInt(addedQuantity.value, 10);
            value = isNaN(value) ? 0 : value;
            value++;
            addedQuantity.value = value;
          });
        }
        if (decreaseQuantity) {
          decreaseQuantity.addEventListener("click", function () {
            var value = Math.max(2, parseInt(addedQuantity.value, 10));
            value = isNaN(value) ? 0 : value;
            value--;
            addedQuantity.value = value;
          });
        }
      });

    })
  });

}

/*
productForm();
*/

document.addEventListener('click', function (event) {
  if (event.target.hasAttribute('data-fetch-url')) {
    event.preventDefault();

    var fetchedUrl = event.target.getAttribute('data-fetch-url');
    var fetchedContent = loadQuickViewContent(fetchedUrl);

    fetchedContent.then(function (data) {
      quickViewContainer.innerHTML = data
      quickViewContainer.classList.add('is-open');
      var quickViewOverlay = document.querySelector('.popup-layover');
      quickViewOverlay.classList.add('is-open');
      if (quickViewOverlay) {
        quickViewOverlay.addEventListener("click", function () {
          document.querySelector('#fetchUrlContent').classList.remove('is-open');
          quickViewContainer.innerHTML = '';
          quickViewOverlay.classList.remove('is-open');
        });
      }

      var quickViewCloseBtn = document.querySelector('#quickviewClose');
      if (quickViewCloseBtn) {
        quickViewCloseBtn.addEventListener("click", function () {
          document.querySelector('#fetchUrlContent').classList.remove('is-open');
          document.querySelector('.popup-layover').classList.remove('is-open');
          quickViewContainer.innerHTML = '';
        });
      }
      var increaseQuantity = document.querySelector('#increaseQuantity');
      var decreaseQuantity = document.querySelector('#decreaseQuantity');
      var addedQuantity = document.querySelector('#Quantity');

      if (increaseQuantity) {
        increaseQuantity.addEventListener("click", function () {
          var value = parseInt(addedQuantity.value, 10);
          value = isNaN(value) ? 0 : value;
          value++;
          addedQuantity.value = value;
        });
      }
      if (decreaseQuantity) {
        decreaseQuantity.addEventListener("click", function () {
          var value = Math.max(2, parseInt(addedQuantity.value, 10));
          value = isNaN(value) ? 0 : value;
          value--;
          addedQuantity.value = value;
        });
      }
    });

  }
})

var loadMoreBtn = document.querySelector('#btnLoadMore');
if (loadMoreBtn) {
  loadMoreBtn.addEventListener('click', function () {
    productForm();
  })
}

window.termsValidation = function (event) {
  var checkoutBtn = document.querySelector('#checkoutBtn');
  var formSubmit = document.querySelector('form[action="/cart"].ajaxcart');
  if (formSubmit) {
    formSubmit.addEventListener('submit', function (e) {
      e.preventDefault();

      var notApprove = document.querySelector('#notApproveBtn');
      if (notApprove) {
        notApprove.addEventListener('click', function () {
          document.querySelector('.popup-cart-wrapper').classList.remove('is-open');
          document.querySelector('.popup-layover').classList.remove('is-open');
        });
      }

    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      var checkBox = document.querySelector('#acceptTermsDrawer');
      if (checkBox.checked) {
        location.href = "/checkout";
      } else {
        document.querySelector('.popup-cart-wrapper').classList.add('is-open');
        document.querySelector('.popup-layover').classList.add('is-open');
        document.querySelector('#approveBtn').addEventListener("click", function () {
          location.href = "/checkout";
        });
        return false;
      }
    });
  }
}


document.addEventListener('DOMContentLoaded', function () {
  var checkoutBtn = document.querySelector('#checkoutBtn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault()
      var checkBox = document.querySelector('#acceptTerms');
      if (checkBox.checked) {

        document.querySelector('#realCheckoutBtn').click();
      } else {
        document.querySelector('.popup-cart-wrapper').classList.add('is-open');
        document.querySelector('.popup-layover').classList.add('is-open');
        document.querySelector('#approveBtn').addEventListener("click", function () {
          document.querySelector('#realCheckoutBtn').click();
        });
        return false;
      }
    });
  }

  var notApprove = document.querySelector('#notApproveBtn');
  if (notApprove) {
    notApprove.addEventListener('click', function () {
      document.querySelector('.popup-cart-wrapper').classList.remove('is-open');
      document.querySelector('.popup-layover').classList.remove('is-open');
    });
  }


  var checkoutBtn = document.querySelector('#checkoutBtnTwo');
  if (checkoutBtn) {

    checkoutBtn.addEventListener('click', function (e) {

      e.preventDefault()
      var checkBox = document.querySelector('#acceptTermsTwo');
      if (checkBox.checked) {

        document.querySelector('#realCheckoutBtnTwo').click();
      } else {
        document.querySelector('.popup-cart-wrapper-two').classList.add('is-open');
        document.querySelector('.popup-layover-two').classList.add('is-open');
        document.querySelector('#approveBtnTwo').addEventListener("click", function () {
          document.querySelector('#realCheckoutBtnTwo').click();
        });
        return false;
      }
    });
  }

  var notApprove = document.querySelector('#notApproveBtnTwo');
  if (notApprove) {
    notApprove.addEventListener('click', function () {
      document.querySelector('.popup-cart-wrapper-two').classList.remove('is-open');
      document.querySelector('.popup-layover-two').classList.remove('is-open');
    });
  }
});


var translations = document.querySelector('#wetheme-global');
var translation = JSON.parse(translations.innerHTML);
var alreadySubscribed = translation.translations.errormessage;
var newsletterSuccess = document.querySelector('.newsletter-success');

var klaviyoForms = document.querySelectorAll('[data-newsletter]');
klaviyoForms.forEach(function (form) {
  var listId = form.dataset.newsletter
  var message = form.querySelector('[data-message]')

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    subscribe(listId, form.email.value).then(function (response) {
      if (response.success && message) message.classList.add('is-visible')
      if (response.data.is_subscribed) alert(alreadySubscribed)
    });
  });
});


function subscribe(listId, email) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var config = Object.assign({}, params, {
    g: listId,
    email: email
  });
  var body = Object.keys(config).reduce(function (str, key) {
    str.append(key, config[key]);
    return str;
  }, new URLSearchParams());
  return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
    method: 'POST',
    headers: {
      "Access-Control-Allow-Headers": "*",
      "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
    },
    body: body
  }).then(function (res) {
    return res.json();
  });
}

var navItems = document.querySelectorAll('.mobile-nav__item')
navItems.forEach(function (item) {
  var close = item.querySelector('[data-close]')

  if (close) {
    close.addEventListener('click', function (event) {

      var parentItem = item.querySelector('.mobile-nav__has-sublist');
      parentItem.classList.remove('mobile-nav--expanded');
    })
  }

})

function afterDrawerClose() {
  var navItem = document.querySelector('.mobile-nav__item');
  navItem.forEach(function () {
    document.querySelector('.mobile-nav__has-sublist').classList.remove('mobile-nav--expanded');
  });
}